export default __webpack_public_path__ + "static/media/MBCorpoATitleCondOffice-Regular.01554c46.ttf";